import React, { useRef, useEffect } from "react";
import { Flex, Select, Space, Tag } from "antd";
import { BarcodeOutlined } from "@ant-design/icons";

const ScanSelect = ({ onValueChange, value, options, placeholder, size, length, capacityCheck = false }) => {
  const { Option } = Select;
  const bufferRef = useRef("");
  const timerRef = useRef(null);
  const isFocusedRef = useRef(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isFocusedRef.current) return;

      if (event.key === "Enter") {
        if (bufferRef.current.length > 0) {
          onValueChange?.(bufferRef.current, true);
          bufferRef.current = "";
        }
      } else if (event.key !== "Shift") {
        bufferRef.current += event.key;
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => (bufferRef.current = ""), 300);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onValueChange]);

  const handleChange = (val) => {
    onValueChange?.(val, false);
  };

  return (
      <Select
        onFocus={() => (isFocusedRef.current = true)}
        onBlur={() => (isFocusedRef.current = false)}
        placeholder={placeholder}
        size={size || "large"}
        showSearch
        style={{ width: length }}
        filterOption={(input, option) =>
          option?.props?.['data-searchlabel']?.toLowerCase().includes(input.toLowerCase())
        }
        optionLabelProp="label"
        value={value || null}
        onChange={handleChange}
        prefix={<BarcodeOutlined style={{ fontSize: 23 }} />}
      >
        {options.map((item) => {
          const baseLabel = `${item.code}`;

          const tags = (
            <Space size={4}>
              {item.is_picking > 0 && (
                <Tag color="green">Picking</Tag>
              )}
              {item.is_binning > 0 && (
                <Tag color="warning">Binning</Tag>
              )}
              {item.is_transit > 0 && (
                <Tag color="red">Transit</Tag>
              )}
             
            </Space>
          );

          const quantityTag = item?.quantity > 0 ? (
            <Tag color="blue">{`Qty: ${item?.quantity}`}</Tag>
          ) : null;

          const capaity =  Number(item?.remaining_capacity) > 0 && !item?.quantity > 0 ? (
            <Tag color="blue">{`Capacity: ${item?.remaining_capacity} `}</Tag>
          ) : <Tag color="red">{`Capacity: ${item?.remaining_capacity}`}</Tag>;

          return (
            <Option
              key={item.id}
              value={item.id}
              data-searchlabel={`${item.code} ${item.title}`}
              label={
                <Flex justify="space-between" align="center" >
                  <span>
                    {tags} {baseLabel}
                  </span>
                  <Flex justify="end">
                  {quantityTag}
                  {
                    capacityCheck ? capaity : null
                  }
                  {/* {capaity} */}
                  </Flex>
                </Flex>
              }
            >
              <Flex justify="space-between" align="center" >
                  <span>
                    {tags} {baseLabel}
                  </span>
                  <Flex justify="end">
                  {quantityTag}
                  {
                    capacityCheck ? capaity : null
                  }
                  </Flex>
                </Flex>
            </Option>
          );
        })}

      </Select>
  );
};

export default ScanSelect;
